import Helpers from '@/lib/helpers'
const state = {
    active: false,
    type: null,
    previous: null,
}

const getters = {
    record_loaded: state => (!!state.active.id),
    order_loaded: state => (state.type == 'order'),
    quote_loaded: state => (state.type == 'quote'),
    bid_loaded: state => (state.type == 'bid'),
    event_loaded: state => (state.type == 'event'),
    mailbatch_loaded: state => (state.type == 'mailbatch'),
    item_loaded: state => (state.type == 'item'),
    location_loaded: state => (state.type == 'location'),
    offer_loaded: state => (state.type == 'offer'),
    message_loaded: state => (state.type == 'message'),
    vendor_loaded: state => (state.type == 'vendor'),
    customer_loaded: state => (state.type == 'customer'),
    active_record: state => state.active,
}

const mutations = {
    record_start(state, payload) {
        state.active = payload.record
        state.type = payload.type
    },
    record_stop(state) {
        state.previous = {
            type: state.type,
            active: {...state.active}
        }
        state.active = false
        state.type = null
    },
    record_restore(state, force) {
        if (state.previous && (!state.active || force)) {
            state.active = {...state.previous.active};
            state.type = state.previous.type
        }
    }
}

const actions = {
    async record_load({ commit, state }, payload){
        payload = payload || {type: state.type}
        payload.type = payload.type || state.type
        const url = payload.url || (state.active && state.active._links.self_url)

        if (url) {
            // noload:  dont show loading spinner if refreshing
            try {
                const record = await Helpers.asyncAction(url.href, url.method, {
                    ...payload.options,
                    noload: !payload.url || payload.noload
                })
                commit('record_start', { record, type: payload.type })
                return record
            } catch (e) {
                throw e
            }
        }

        return null
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}